import { Link, useLocation } from 'react-router-dom'

const RefreshableLink = ({ to, children, ...props }) => {
  const location = useLocation()

  const handleClick = (e) => {
    if (location.pathname === to) {
      e.preventDefault() // stop normal link behavior
      window.location.href = to // force refresh
    }
  }

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}

export default RefreshableLink
